import { Head, useForm } from '@inertiajs/react'

export default function Login() {
  const { data, setData, post, processing, errors } = useForm({
    email: '',
    password: '',
  })

  function submit(e) {
    e.preventDefault()
    post('/login')
  }

  return (
    <div className="page">
      <Head title="Área de Organização" />
      <div className="login-wrap">
        <form className="login" onSubmit={submit}>
          <div className="crest">
            <img src="/cabreiroscup_logo.png" alt="Cabreiros Cup" />
          </div>
          <h3>Área de Organização</h3>
          <p>Cabreiros Cup 2026</p>
          <div className="field">
            <label>Email</label>
            <input
              type="email"
              value={data.email}
              onChange={(e) => setData('email', e.target.value)}
              autoComplete="username"
            />
          </div>
          <div className="field">
            <label>Palavra-passe</label>
            <input
              type="password"
              value={data.password}
              onChange={(e) => setData('password', e.target.value)}
              autoComplete="current-password"
            />
          </div>
          {errors.base && (
            <p style={{ color: 'var(--red)', fontStyle: 'normal', margin: '0 0 12px' }}>
              {errors.base}
            </p>
          )}
          <button className="btn" type="submit" disabled={processing}>
            Entrar
          </button>
        </form>
      </div>
    </div>
  )
}
